import axios from "axios";

const API = axios.create({
  baseURL: "https://628e5933a339dfef87acab6d.mockapi.io",
});

export default API;
